import { render, staticRenderFns } from "./LegendLastSeason.vue?vue&type=template&id=ceae146c&scoped=true&"
import script from "./LegendLastSeason.vue?vue&type=script&lang=js&"
export * from "./LegendLastSeason.vue?vue&type=script&lang=js&"
import style0 from "./LegendLastSeason.vue?vue&type=style&index=0&id=ceae146c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceae146c",
  null
  
)

export default component.exports